// extracted by mini-css-extract-plugin
module.exports = {"choose_store":"ChooseStoreButton_choose_store__ZKnoE","button":"ChooseStoreButton_button__Wmgih"};